import * as syncUiActions from './syncUiActions'
import { syncUiType as _syncUiType } from './syncUiTypes'

export const syncUiType = _syncUiType
export default syncUiActions
